import userLoadInfo from './user-load-info';
import profileList from './profile-list';
import profileDetail from './profile-view';
import profileForm from './profile-form';
import slipForm from './slip-form';
import userList from './user-list';
import userForm from './user-form';
import companyDetail from './company-detail';
import companyEdit from './company-edit';

export default {
  userLoadInfo,
  profileList,
  profileDetail,
  profileForm,
  slipForm,
  userList,
  userForm,
  companyDetail,
  companyEdit,
};



// WEBPACK FOOTER //
// ./src/pages/biller/index.js